<app-status-tab class="app-status-tab"
                *ngFor="let tab of tabs" [tab]="tab"
                (tabSelected)="onTabSelected($event)">
</app-status-tab>
